import React from 'react';
import StartSurvey from './start-survey/start-survey';
import AnswerTheSurvey from './answer-the-survey/answer-the-survey';
import EndSurvey from './end-survey/end-survey';
import { Box } from '@mui/material';
import Sidebar from 'layouts/components/survey-sidebar';
import EndSurveyFullQuota from '../page-logic-survey/end-survey/end-survey-full-quota';

const Survey = () => {
    const [surveyStep, setSurveyStep] = React.useState<number>(0);

    const config: Record<number, React.ReactElement> = {
        0: <StartSurvey setSurveyStep={setSurveyStep} />,
        1: <AnswerTheSurvey setSurveyStep={setSurveyStep} />,
        2: <EndSurvey setSurveyStep={setSurveyStep} />,
        3: <EndSurveyFullQuota setSurveyStep={setSurveyStep} />,
    };

    return (
        <Box>
            <Sidebar
                surveyStep={surveyStep}
                setSurveyStep={() => setSurveyStep(0)}
            />
            {config[surveyStep]}
        </Box>
    );
};

export default Survey;
